import { render, staticRenderFns } from "./EpaFooter.vue?vue&type=template&id=325998d6&scoped=true"
import script from "./EpaFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./EpaFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EpaFooter.vue?vue&type=style&index=0&id=325998d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325998d6",
  null
  
)

export default component.exports